import { Table } from '@landsvirkjun/react.common';
import React from 'react';
import { columns } from './ActivityLogTableModels';
import { Box, Heading } from '@chakra-ui/layout';
import { PageHeader } from 'routes/layouts/pageHeader';
import { useLocation } from 'react-router-dom';
import { useActivityLogsQuery } from 'api/services/ActivityLogs';
import { LoadingContainer } from 'components/LoadingContainer/LoadingContainer';
import { Alert, AlertIcon } from '@chakra-ui/react';

type ActivityLogProps = {
  showHeader?: boolean;
};
export const ActivityLog = ({
  showHeader = true,
}: ActivityLogProps): JSX.Element => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');

  const { data: activityData = [], isLoading } = useActivityLogsQuery(id);

  const sortedData = [...activityData].sort((a, b) => {
    const dateA = new Date(a.updatedDate).getTime();
    const dateB = new Date(b.updatedDate).getTime();
    return dateA - dateB;
  });

  const processedData = sortedData.map((item, index) => {
    if (index === 0) {
      return {
        ...item,
        previousStatus: '',
        currentStatus: item.status.shortName,
      };
    } else {
      const prevItem = sortedData[index - 1];
      const prevShortName = prevItem.status.shortName;
      const currentShortName = item.status.shortName;
      return {
        ...item,
        previousStatus: prevShortName,
        currentStatus: currentShortName,
      };
    }
  });

  return (
    <Box as="div">
      {showHeader && (
        <PageHeader
          left={
            <Box alignItems="center" display="flex">
              <Heading as="h2" size="lg" mr={2}>
                Aðgerðarsaga
              </Heading>
              <Heading
                as="h2"
                size="lg"
                style={{ color: 'gray', fontSize: '1.5rem' }}
              >
                ({id})
              </Heading>
            </Box>
          }
        />
      )}
      <Box as="div" mt={10}>
        {/* TODO mögulega er bara fínt að leyfa að loka þessu og vista það í localstorage */}
        <Alert status="info" variant="left-accent">
          <AlertIcon />
          Aðgerðarsagan sýnir framgang og stöðu samþykkta ferðabeiðnar og
          kostnaðar.
        </Alert>
        <LoadingContainer isLoaded={!isLoading} hasSpinner>
          <Table
            data={processedData}
            columns={columns}
            withPagination={false}
          />
        </LoadingContainer>
      </Box>
    </Box>
  );
};
